import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { LOADER_TYPE, Loader } from '@shared/components/loader/loader.model';

@Injectable({ providedIn: 'root' })
export class LoaderService {
  protected loader$ = new BehaviorSubject<Loader>({
    status: false,
    type: LOADER_TYPE.INFINITE,
  });

  init(loader: Loader = { status: true, type: LOADER_TYPE.INFINITE }) {
    this.loader$.next(loader);
  }

  getLoader() {
    return this.loader$.asObservable();
  }
}
